// extracted by mini-css-extract-plugin
module.exports = {"main_container":"AssetTypeDetailPage_main_container__2L2ts","red_text":"AssetTypeDetailPage_red_text__1erCx","delete_buttons":"AssetTypeDetailPage_delete_buttons__2ymNZ"};